module.exports = __webpack_public_path__ + "static/media/invoices_converter.e061c639.mov";